import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const MARTY_CAGAN_TZ = 'America/Los_Angeles';

/** Inclusive start: April 8, 2026, midnight America/Los_Angeles. */
export const MARTY_CAGAN_ATF_SLOT_START_ISO_LOCAL = '2026-04-08T00:00:00';

/**
 * Exclusive end: Thursday April 23, 2026, 9:00am America/Los_Angeles.
 * Active when now is strictly before this instant.
 */
export const MARTY_CAGAN_ATF_SLOT_END_ISO_LOCAL = '2026-04-23T09:00:00';

/**
 * Whether the Marty Cagan ATF promo slot is active at the given instant.
 * Uses `>=` start (inclusive) and `<` end (exclusive) in America/Los_Angeles.
 */
export function isMartyCaganAtfSlotActive(now: dayjs.Dayjs): boolean {
  const start = dayjs.tz(MARTY_CAGAN_ATF_SLOT_START_ISO_LOCAL, MARTY_CAGAN_TZ);
  const end = dayjs.tz(MARTY_CAGAN_ATF_SLOT_END_ISO_LOCAL, MARTY_CAGAN_TZ);

  return (now.isSame(start) || now.isAfter(start)) && now.isBefore(end);
}
